import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Protected = (props) => {
  let Cmp = props.Cmp;
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("loginInfo")) {
      navigate("/login", { replace: true });
    }
  }, [navigate]);
  return (
    <>
      <Cmp />
    </>
  );
};

export default Protected;
